import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const Home = lazy(() => import('../pages/home/page'));
const APropos = lazy(() => import('../pages/a-propos/page'));
const Gestion = lazy(() => import('../pages/gestion/page'));
const BaseDeDonnees = lazy(() => import('../pages/base-de-donnees/page'));
const Reseaux = lazy(() => import('../pages/reseaux/page'));
const Telecommunication = lazy(() => import('../pages/telecommunication/page'));
const Tracking = lazy(() => import('../pages/tracking/page'));
const Maintenance = lazy(() => import('../pages/maintenance/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const Programmation = lazy(() => import('../pages/programmation/page'));
const SystemeInformatique = lazy(() => import('../pages/systeme-informatique/page'));

// Admin pages
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminClients = lazy(() => import('../pages/admin/clients/page'));
const AdminDevis = lazy(() => import('../pages/admin/devis/page'));
const AdminSuivi = lazy(() => import('../pages/admin/suivi/page'));
const AdminLeads = lazy(() => import('../pages/admin/leads/page'));
const AdminRendezVous = lazy(() => import('../pages/admin/rendez-vous/page'));

const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/a-propos', element: <APropos /> },
  { path: '/gestion', element: <Gestion /> },
  { path: '/base-de-donnees', element: <BaseDeDonnees /> },
  { path: '/reseaux', element: <Reseaux /> },
  { path: '/telecommunication', element: <Telecommunication /> },
  { path: '/tracking', element: <Tracking /> },
  { path: '/maintenance', element: <Maintenance /> },
  { path: '/programmation', element: <Programmation /> },
  { path: '/systeme-informatique', element: <SystemeInformatique /> },
  { path: '/contact', element: <Contact /> },
  // Admin routes
  { path: '/admin/login', element: <AdminLogin /> },
  { path: '/admin/dashboard', element: <AdminDashboard /> },
  { path: '/admin/clients', element: <AdminClients /> },
  { path: '/admin/devis', element: <AdminDevis /> },
  { path: '/admin/suivi', element: <AdminSuivi /> },
  { path: '/admin/leads', element: <AdminLeads /> },
  { path: '/admin/rendez-vous', element: <AdminRendezVous /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
